;(function () {
	'use strict';

	if (!customElements.get('trending-collections')) {
		class TrendingCollections extends HTMLElement {
			constructor() {
				super();
				this.slider = this.querySelector('.swiper.trending-collections__slider');
				this.nextBtns = Array.from(this.querySelectorAll('.next'));
				this.prevBtns = Array.from(this.querySelectorAll('.prev'));
				this.swiper = null;
				this.onResize = this.handleResize.bind(this);
			}

			connectedCallback() {
				this.initSwiper();
				window.addEventListener('resize', this.onResize);

				this.nextBtns.forEach((btn, ind) => {
					if (ind === 0) return;
					btn.addEventListener('click', () => this.swiper?.slideNext());
				});

				this.prevBtns.forEach((btn, ind) => {
					if (ind === 0) return;
					btn.addEventListener('click', () => this.swiper?.slidePrev());
				});
			}

			disconnectedCallback() {
				window.removeEventListener('resize', this.onResize);
				this.destroySwiper();
			}

			handleResize() {
				this.initSwiper();
			}

			destroySwiper() {
				if (this.swiper) {
					this.swiper.destroy(true, true);
					this.swiper = null;
				}
			}

			initSwiper() {
				if (!this.slider) return;

				this.destroySwiper();

				const autoplayEnabled = this.dataset.autoplay === 'true';
				const autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 5000;
				const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

				const swiperOptions = {
					loop: true,
					speed: 400,
					spaceBetween: 30,
					slidesPerView: 1,
					breakpoints: {
						750: {
							slidesPerView: 2
						},
						990: {
							slidesPerView: 3
						},
						1100: {
							slidesPerView: 4
						}
					},
					navigation: {
						nextEl: this.nextBtns[0],
						prevEl: this.prevBtns[0],
						disabledClass: 'nav--disabled'
					}
				};

				if (autoplayEnabled && !reducedMotion) {
					swiperOptions.autoplay = {
						delay: autoplaySpeed,
						disableOnInteraction: false,
						pauseOnMouseEnter: true
					};
				}

				this.swiper = new Swiper(this.slider, swiperOptions);
			}
		}

		customElements.define('trending-collections', TrendingCollections);
	}
})();
